import { useMemo, useEffect, useRef, useState } from 'react';
import { Container, Col, Dropdown, Row } from 'react-bootstrap';
import { BzDropdown, BzMasterAgGrid } from '../../components';
import { getMarketMovementInfo } from '../../redux/actions/marketOverview';
import { getApiExchangeNameFromMktSegId, getMktSegIdFromMappedMktSegId, getScripDisplayDescription, getDynamicParamsForToFixed } from '../../utils/global_functions';
import { WATCHLIST_GRID_INDEX, MARKET_MOVEMENT } from "../../utils/global_variables";
import { useSelector, useDispatch } from 'react-redux';
const objDropdownOptions = {
    TimeInterval: [10, 15, 30, 60],

};
//Vaibhav Singh : Market Movement: BT-109073:  08-11-2023: Removed Props unused : Start
const MarketMovement = ({ isVertical=true,handleDropClickMarketMovement,showDropMarketMoveMent }) => {
    //Vaibhav Singh : Market Movement: BT-109073: 08-11-2023: Removed Props unused : End
    //Kamesh : 27-07-2023 : BT-BT-109073 -   Breeze – Scrip Overview – Market Movement - Start

    const dispatch = useDispatch();
    const marketMovementRef = useRef();
    //Vaibhav Singh: Market Movement: 08-11-2023: BT-109073:Scripoverview imported from redux : Start
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    const [fileName, setFileName] = useState('');
    //Vaibhav Singh: Market Movement: 08-11-2023:BT-109073: Scripoverview imported from redux : End
    const marketMovementInfo = useSelector(state => state.marketOverview.marketMovementInfo);

    const [selectTimeInterval, setSelectTimeInterval] = useState(MARKET_MOVEMENT.TIME_INTERVAL);
    //BT-120319 : Scrip Overview – Market Movement : Bug Fixing : Manasa B : 23/10/2023 - Start
    const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]));
    const decimalLocatorLength = getDynamicParamsForToFixed(exchangeName);
    const arrMarketMovementColumnDefs = useMemo(() => [
        { field: "Time", headerName: "TIME", filter: 'agTextColumnFilter' },
        { field: "nOpen", headerName: "OPEN", filter: 'agNumberColumnFilter', valueFormatter: params => params.value.toFixed(decimalLocatorLength) },
        { field: "nHigh", headerName: "HIGH", filter: 'agNumberColumnFilter', valueFormatter: params => params.value.toFixed(decimalLocatorLength) },
        { field: "nLow", headerName: "LOW", filter: 'agNumberColumnFilter', valueFormatter: params => params.value.toFixed(decimalLocatorLength) },
        { field: "nClose", headerName: "CLOSE", filter: 'agNumberColumnFilter', valueFormatter: params => params.value.toFixed(decimalLocatorLength) },
        { field: "nATP", headerName: "ATP", filter: 'agNumberColumnFilter', valueFormatter: params => params.value.toFixed(decimalLocatorLength) },
        { field: "nTotalQtyTraded", headerName: "TOTAL TRADED QTY", filter: 'agNumberColumnFilter' },
        { field: "nTotalValueTraded", headerName: "TOTAL TRADED VALUE(IN LAKHS)", filter: 'agNumberColumnFilter' },
        //BT-120319 : Scrip Overview – Market Movement : Bug Fixing : Manasa B : 23/10/2023 - End
    ], []);
    useEffect(() => {
        if (scripOverviewData?.length > 0) {
            const objMarketMovementPaylod = {
                MktSegId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                Token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                TimeInterval: parseInt(selectTimeInterval)
            };
            dispatch(getMarketMovementInfo(objMarketMovementPaylod));
            //Vaibhav Singh: Market Movement: 08-11-2023:BT-109073: FileName Format Set here : Start
            const fileNameExchange = getScripDisplayDescription(scripOverviewData);
            setFileName(`${scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL]}_${scripOverviewData[WATCHLIST_GRID_INDEX.EXCHANGE]}_${fileNameExchange?.split(" ")?.join("")}_MarketMovement.xlsx`);
            //Vaibhav Singh: Market Movement: 08-11-2023:BT-109073: FileName Format Set here : End
        } else { }
    }, [scripOverviewData, selectTimeInterval, dispatch]);

    //Vaibhav Singh: Market Movement: 08-11-2023:BT-109073: Funtion to export excel filefor marketmoment Updated : Start
    const onExportMarketMovement = () => {
        marketMovementRef?.current?.api?.exportDataAsExcel({
            fileName: fileName,
            processCellCallback(params) {
                if (params?.column?.colDef?.field !== ("Time" || "nTotalQtyTraded" || "nTotalValueTraded")) {
                    return `${parseFloat(params?.value)?.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])}`;
                } else {
                    return params?.value;
                }
            }
        });
    };
    //Vaibhav Singh: Market Movement: 08-11-2023:BT-109073: Funtion to export excel filefor marketmoment Updated : End

    //Funtion to change specific time interval for marketmoment
    const handleChangeTimeInterval = (e) => {
        // const { value } = e.target;
        setSelectTimeInterval(e);


    };
    //Kamesh : 27-07-2023 : BT-BT-109073 -   Breeze – Scrip Overview – Market Movement - End

    

    return (
        <div className='scripoverview-fieldset'>
            <div className='scripoverview-legend'>MARKET MOVEMENT</div>
            <Container fluid className={`${isVertical?'':showDropMarketMoveMent?'':'scripoverview-fieldset-sidetray'} p-0 ${isVertical?'pb-2':''} mt-3`}>
                <Row className='g-0'>
                    <Col>
                        <Row className='g-0 align-items-center'>
                            <Col md='auto' className='d-flex justify-content-start'>
                                <div className={`font-medium color-text pe-2 ${isVertical?'font-size4':'font-size2'}`}>Select Time Interval (mins):</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-start'>
                                <div className='Bzselect-dropdown'>
                                    <BzDropdown>
                                        <Dropdown.Toggle className='btn-default'>{selectTimeInterval}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {
                                                objDropdownOptions?.TimeInterval?.map((each, i) => (
                                                    <Dropdown.Item key={i} onClick={() => handleChangeTimeInterval(each)}>{each}</Dropdown.Item>
                                                ))
                                            }
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>
                            </Col>
                        </Row>
                        <BzMasterAgGrid
                            isFirstRowSelected={false}
                            arrColumnData={arrMarketMovementColumnDefs}
                            arrRowData={marketMovementInfo}
                            rowHeight={36}
                            className='ag-theme-alpine market-movement-grid mt-3'
                            ref={marketMovementRef} />
                    </Col>
                </Row>
            </Container>
            <div className='fixed-icons-wrapper'>
                <div className='d-flex justify-content-end align-items-center'>
                    <div className='background-icon' onClick={() => onExportMarketMovement()}>
                        <div className='icon-16 icon-download icon-dark'></div>
                    </div>
                </div>
            </div>
            {!isVertical?
                <div className='scripoverview-expand-btn-wrapper' onClick={handleDropClickMarketMovement}>
                    <div className='scripoverview-expand-btn'>
                        <div className={`icon-12 ${showDropMarketMoveMent?'icon-arrowup':'icon-arrowdown'} icon-dark`}></div>
                    </div>
                </div>:null
            }
        </div>
    );
};

export default MarketMovement; 